import React from "react";
import { Route, Routes } from "react-router-dom";
import { useAdminAuth } from "./AdminAuth";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import Dashboard from "./pages/Dashboard";
import PagesAdmin from "./pages/PagesAdmin";
import PageEditor from "./pages/PageEditor";
import CatalogueAdmin from "./pages/CatalogueAdmin";
import ProductsAdmin from "./pages/ProductsAdmin";
import StockAdmin from "./pages/StockAdmin";
import WeightsAdmin from "./pages/WeightsAdmin";
import ContentPolish from "./pages/ContentPolish";
import MediaAdmin from "./pages/MediaAdmin";
import BuildsAdmin from "./pages/BuildsAdmin";
import ReviewsAdmin from "./pages/ReviewsAdmin";
import NavAdmin from "./pages/NavAdmin";
import EnquiriesAdmin from "./pages/EnquiriesAdmin";
import ContactsAdmin from "./pages/ContactsAdmin";
import CampaignsAdmin from "./pages/CampaignsAdmin";
import OrdersAdmin from "./pages/OrdersAdmin";
import SettingsAdmin from "./pages/SettingsAdmin";
import RacexAdmin from "./pages/RacexAdmin";
import { PageLoader } from "../components/States";

export default function AdminRoutes() {
  const { user, loading } = useAdminAuth();

  if (loading) return <PageLoader label="Checking access" />;
  if (!user) return <AdminLogin />;

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="pages" element={<PagesAdmin />} />
        <Route path="pages/edit/*" element={<PageEditor />} />
        <Route path="catalogue" element={<CatalogueAdmin />} />
        <Route path="products" element={<ProductsAdmin />} />
        <Route path="stock" element={<StockAdmin />} />
        <Route path="weights" element={<WeightsAdmin />} />
        <Route path="polish" element={<ContentPolish />} />
        <Route path="media" element={<MediaAdmin />} />
        <Route path="builds" element={<BuildsAdmin />} />
        <Route path="reviews" element={<ReviewsAdmin />} />
        <Route path="nav" element={<NavAdmin />} />
        <Route path="enquiries" element={<EnquiriesAdmin />} />
        <Route path="contacts" element={<ContactsAdmin />} />
        <Route path="mailouts" element={<CampaignsAdmin />} />
        <Route path="orders" element={<OrdersAdmin />} />
        <Route path="settings" element={<SettingsAdmin />} />
        <Route path="racex" element={<RacexAdmin />} />
      </Route>
    </Routes>
  );
}
